import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import DprReportTab from "./DprReportTab";
import CompletedPilesTab from "./CompletedPilesTab";
import { NoAccess } from "../equipment/shared/NoAccess";

const DPR_ROLES = ["Director", "Manager", "Back Office"];
const PILE_EXPORT_ROLES = ["Director", "Manager", "Accounts", "Back Office"];

const TABS = [
  { key: "dpr", label: "Equipment Monthly Log (DPR)", Component: DprReportTab, roles: DPR_ROLES },
  { key: "completed-piles", label: "Completed Piles Export", Component: CompletedPilesTab, roles: PILE_EXPORT_ROLES },
];

export default function ReportsPage() {
  const { user } = useAuth();
  const visible = TABS.filter((t) => t.roles.includes(user?.role));
  const [active, setActive] = useState(visible[0]?.key);

  if (visible.length === 0) return <NoAccess />;

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
          Reports
        </h1>
        <p className="text-sm text-slate-500">Equipment Monthly Log Report and Completed Piles export.</p>
      </div>
      <Tabs value={active} onValueChange={setActive}>
        <TabsList className="flex-wrap h-auto">
          {visible.map((t) => (
            <TabsTrigger key={t.key} value={t.key} data-testid={`reports-tab-${t.key}`}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {visible.map((t) => (
          <TabsContent key={t.key} value={t.key} className="pt-4">
            <t.Component />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
